import Snils from './ui/Snils';

export default Snils;